// Touch feedback (A3.3): when a contact starts, both phones buzz briefly and
// play a soft "tick". Synthesised with WebAudio (no audio file); Capacitor
// Haptics is not a dependency of this app, so navigator.vibrate is used.

let ctx: AudioContext | null = null;

/** Call from a user gesture once so mobile browsers allow audio later. */
export function unlockAudio() {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
  } catch { /* no WebAudio */ }
}

export function tick() {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    const t = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(1320, t);
    osc.frequency.exponentialRampToValueAtTime(880, t + 0.08);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.12, t + 0.008);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.14);
  } catch { /* no WebAudio */ }
}

export function buzz(ms = 30) {
  try { navigator.vibrate?.(ms); } catch { /* unsupported */ }
}

export function touchFeedback() {
  buzz(30);
  tick();
}
